import React, { useState, useEffect } from 'react';
import {Drawer, Row, Col, Input, AutoComplete, Divider,  Space, Button, DatePicker, Select, Avatar} from 'antd';
import {useAxios} from '../../../../hooks';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRedo, faExchange, faBoxCheck } from '@fortawesome/pro-solid-svg-icons'
import { faBoxOpen } from '@fortawesome/pro-duotone-svg-icons';
import {Produtos} from '../../../../contentsys-components';


import moment from 'moment';
import 'moment/locale/pt-br';

const {Option} = Select

const {FormularioCadastroProduto, useNCM }  = Produtos;

moment.locale('pt-br', {
  monthsShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"]
});

let baseProdutos = [];

const useProdutos = () => {
    const {getApiEmitirNotas} = useAxios();

    const {consultaPorcentagemAprxImpostos} = useNCM(getApiEmitirNotas)
    
    const lerProdutos = async (force, termo, setProdutos) => {
        if(baseProdutos.length === 0 || force){
            const axios = await getApiEmitirNotas();
            const params = {termo:termo};
            const result = await axios.get('/produtos/filtro', {params});
            baseProdutos = result.data;    
        }
        return setProdutos(filtraProdutoPorTermo(baseProdutos, termo));
    }

    const salvarSaldoEstoque = async (movimentacao) => {
        const axios = await getApiEmitirNotas();
        // const params = {body: movimentacao};
        const result = await axios.post('/movimentacao-estoque', movimentacao);
        return result.data;
    }

    const filtraProdutoPorTermo = (produtos, termo) => {
        return produtos.filter(produto => {
            if(termo){
                if(produto.codigo.toUpperCase() === termo.toUpperCase() || produto.codigo.toUpperCase().indexOf(termo.toUpperCase()) >= 0){
                    return true;
                }
                if(produto.descricao.toUpperCase() === termo.toUpperCase() || produto.descricao.toUpperCase().indexOf(termo.toUpperCase()) >= 0){
                    return true;
                }
                if(produto.ncm === termo){
                    return true;
                }
            }

            return false;
        });
    }

    return {lerProdutos, salvarSaldoEstoque, consultaPorcentagemAprxImpostos}
}


const ProdutoRenderizado = ({meuProdutoSelecionado, setMeuProdutoSelecionado, produtoFornecedor}) => {


    const [autoCompleteValue, setAutoCompleteValue] = useState('');
    const [options, setOptions] = useState([]);

    const {getApiEmitirNotas} = useAxios();

    const {consultaPorcentagemAprxImpostos} = useProdutos();

    const [formCadastroProdutoVisivel, setFormCadastroProdutoVisivel] = useState(false);
    
    const [formCadastroProdutosInitialValue, setFormCadastroProdutosInitialValue ] = useState(false);

    const [carregandoNCM, setCarregandoNCM] = useState(false); 
    const [labelImportarProduto, setLabelImportarProduto] = useState("Importar Cadastro do Produto"); 

    const produtoFornecedor2Produto = async (produtoFornecedor)=>{
        const { uuid, 
                id,
                updatedAt, 
                createdAt, 
                unidadeComercial, 
                unidadeTributario,
                totalItem,
                statusProcessamentoEstoque,
                quantidadeTributaria,
                quantidade,
                nItem,
                ean,
                uuidProduto,
                valorUn,
                valorUnTrib,
                valoresAdicionais,
                codigo:codigoProduto,
                ...novoProdutoFornecedor} = produtoFornecedor;
        
        const codigo = ean || codigoProduto
    
        const produto = Object.assign({}, novoProdutoFornecedor, {
            uCom: produtoFornecedor.unidadeTributario,
            valorCusto: valorUnTrib,
            codigo,
            importadoNFe: true
        })

        if(produto.ncm && produto.ncm.length == 8 ){

            setLabelImportarProduto("Importar Cadastro do Produto (Aguarde...)")
            setCarregandoNCM(true);
            try{
                produto.porcentagemAproximadaImpostos = await consultaPorcentagemAprxImpostos(produto, produto.ncm);
            } catch(err){
                console.log(err);
            }

            setCarregandoNCM(false);
            setLabelImportarProduto("Importar Cadastro do Produto")

        }
        //return produto;
        setFormCadastroProdutosInitialValue(produto);
    }

    const {lerProdutos} = useProdutos();


    useEffect(()=> {
        if(!meuProdutoSelecionado){
            setAutoCompleteValue('');
        }
    }, [meuProdutoSelecionado])
    useEffect(()=>{
        setAutoCompleteValue('');
        //setMeuProdutoSelecionado(false);
        
    }, [true]);
    
    useEffect(()=> {
        produtoFornecedor2Produto(produtoFornecedor)
        
    }, [produtoFornecedor])

    const removerProdutoSelecionado = () => {
        setMeuProdutoSelecionado(false);
    }

    const onFilter = force => (value) => {
        setAutoCompleteValue(value);
        lerProdutos(force, value, (produtos)=>{
            const newOpts = produtos.map((p) => {
                return { 
                    key: p.id,
                    produto: p,
                    value: p.id,
                    label: (<div><input type="hidden" value={p.id}></input><span style={{fontWeight: "bold"}}>#{p.id} ##{p.codigo}</span> {p.descricao}</div>)
                 }
            });

            setOptions(newOpts);
        });
    };

    const onSelect = (value, instancia) => {
        setMeuProdutoSelecionado(instancia.produto);
        setAutoCompleteValue(instancia.produto.descricao);
    }

    const onSalvarProdutoHandle = (produto) => {
        setMeuProdutoSelecionado(produto.toApiJson());
        setFormCadastroProdutoVisivel(false);
    }

    if(!meuProdutoSelecionado){



        return (<>  
            <Row gutter={[16,16]}>
                <Col span={24}>
                
                    <AutoComplete
                        style={{
                            width: "100%",
                        }}
                        value={autoCompleteValue}
                        dropdownMatchSelectWidth={500}
                        id="searchProduto"
                        
                        onSearch={onFilter(false)}
                        options={options}
                        onSelect={onSelect}
                        
                    >
                        <Input.Search  placeholder="Informe seu produto" enterButton={
                            <FontAwesomeIcon icon={faRedo}></FontAwesomeIcon>
                        }  onSearch={onFilter(true)} />



                        
                    </AutoComplete>
                </Col>
                <Divider></Divider>
                <Col span={3}>
                    <FontAwesomeIcon size="4x" icon={faBoxCheck}></FontAwesomeIcon>
                </Col>
                <Col span={20}>
                    <h3>Cadastro do Produto</h3>
                    <p>Ainda não possui o produto cadastrado? Clique no botão abaixo para cadastrar com base nas informações do seu fornecedor</p>
                    <Button loading={carregandoNCM} type={"primary"} onClick={()=> setFormCadastroProdutoVisivel(true)}>{labelImportarProduto}</Button>
                    
                    <FormularioCadastroProduto initialValue={formCadastroProdutosInitialValue} visible={formCadastroProdutoVisivel} getApi={getApiEmitirNotas} onCancel={()=> setFormCadastroProdutoVisivel(false)} onSave={onSalvarProdutoHandle} type="modal"></FormularioCadastroProduto>

                </Col>
            </Row>
            
        </>)
    } else {
        return(
            <div>
                <span style={{fontSize: "18px"}}>
                    <FontAwesomeIcon icon={faBoxOpen}></FontAwesomeIcon>
                    {meuProdutoSelecionado.descricao}</span> 
                    <Button onClick={removerProdutoSelecionado} danger={true} size="small" icon={(<FontAwesomeIcon icon={faExchange}></FontAwesomeIcon>)}>
                        Trocar
                    </Button>
            </div>
        )
        // return (<Tag closable={true}  onClose={removerProdutoSelecionado}>{meuProdutoSelecionado.descricao}</Tag>)
    }
}

const SelecaoDeConferencia = ({itemFornecedor, produtoSelecionado, onChange = (val)=>{} }) => {
    
    let unidadeFornecedorPadrao = itemFornecedor.unidadeComercial;

    useEffect(()=>{
        onChangeHandler(itemFornecedor.unidadeComercial);
    }, [true]);

    const onChangeHandler = (val)=>{
        if(val == produtoSelecionado.uCom){
            onChange({
                unidade: produtoSelecionado.uCom,
                tipo: "LOCAL"

            })
        } else {
            onChange({
                unidade: itemFornecedor.unidadeComercial,
                tipo: "FORNECEDOR"
            })
            
        }
    }

    

    let opcoes = [
        <Option value={produtoSelecionado.uCom}>{produtoSelecionado.uCom} (Minha Medida)</Option>
    ]

    if(itemFornecedor.unidadeComercial != produtoSelecionado.unidadeComercial){
        
        opcoes.push(<Option value={itemFornecedor.unidadeComercial}>{itemFornecedor.unidadeComercial} (Medida Fornecedor)</Option>);

        if(itemFornecedor.unidadeTributario == produtoSelecionado.unidadeComercial){
            unidadeFornecedorPadrao = itemFornecedor.unidadeTributario;
        }
    }





    
    return <>
        <Row>
            Contar utilizando como unidade de medida:&nbsp;
            <Select defaultValue={unidadeFornecedorPadrao} size='small' onChange={onChangeHandler}>
                {opcoes}
            </Select>
        </Row>
        
    </>
}

const AdicionaSaldoItemNFe = (props) => {

    const { visible, itemSelecionado: itemFornecedorSelecionado, onClose, onSuccess } = props;

    
    
    const [meuProdutoSelecionado, setMeuProdutoSelecionado] = useState(false);
    
    const [quantidadeEntradaExibicao, setQuantidadeEntradaExibicao] = useState({value: 0});
    const [quantidadeEntrada, setQuantidadeEntrada] = useState(0);
    
    const [quantidadeDebitada, setQuantidadeDebitada] = useState(itemFornecedorSelecionado.quantidade);
    const [lote, setLote] = useState('');
    const [validade, setValidade] = useState('');
    const [salvandoMovimentacao, setSalvandoMovimentacao] = useState(false);
    const [fatorTransformacao, setFatorTransformacao] = useState(1);
    let [unidadeMedidaDeConferencia, setUnidadeMedidaDeConferencia] = useState({unidade: '', tipo: "FORNECEDOR"});
    

    const { salvarSaldoEstoque} = useProdutos();


    useEffect(() => {

        setSalvandoMovimentacao(false);
        setQuantidadeEntradaExibicao({value: itemFornecedorSelecionado.quantidade});
        setQuantidadeDebitada(itemFornecedorSelecionado.quantidade);
        setLote('');
        setValidade('');
       
        

    }, [itemFornecedorSelecionado]);

    useEffect(()=>{
        if(meuProdutoSelecionado && itemFornecedorSelecionado){
            atualizaFatorTransformacao();
            atualizaUnidadeMedidaDeConferencia();
        }
    },[meuProdutoSelecionado]);

    useEffect(() => {
        if(meuProdutoSelecionado && itemFornecedorSelecionado){
            atualizaValorEntradaExibicao();
        } else {
            setQuantidadeEntradaExibicao({value: 0});
        }
    },[fatorTransformacao,unidadeMedidaDeConferencia])

    useEffect(() => {
        console.log("fui chamado")
        if(meuProdutoSelecionado && itemFornecedorSelecionado){
            atualizaValorEntrada();
        } else {
            setQuantidadeEntrada(0);
        }
    },[quantidadeEntradaExibicao])

    useEffect(()=>{
        //setAutoCompleteValue('');
        setMeuProdutoSelecionado(false);
        
    }, [visible]);

    const atualizaValorEntrada = ()=>{
        let valorEntrada = quantidadeEntradaExibicao.value;
        if(unidadeMedidaDeConferencia.tipo == "FORNECEDOR"){
            console.log("fator transformacao", fatorTransformacao);
            console.log("quantidadeEntradaExibicao", quantidadeEntradaExibicao.value);
            valorEntrada = quantidadeEntradaExibicao.value * fatorTransformacao;
        }
        setQuantidadeEntrada(valorEntrada);
    }

    const atualizaValorEntradaExibicao = () => {
               
        let quantidadeEntradaExibicao = itemFornecedorSelecionado.quantidade;
        
        
        if(unidadeMedidaDeConferencia.tipo == "LOCAL"){
            quantidadeEntradaExibicao = fatorTransformacao * itemFornecedorSelecionado.quantidade;
        }  

        
        
        setQuantidadeEntradaExibicao({value: quantidadeEntradaExibicao});

   }

    const atualizaFatorTransformacao = ()=>{
        let fatorTransformacao = 1;
           
        if(itemFornecedorSelecionado.unidadeTributario == meuProdutoSelecionado.uCom){
            fatorTransformacao = itemFornecedorSelecionado.quantidadeTributaria / itemFornecedorSelecionado.quantidade;
        }

        setFatorTransformacao(fatorTransformacao);
    }

    const atualizaUnidadeMedidaDeConferencia = ()=>{
        setUnidadeMedidaDeConferencia({
            tipo: "FORNECEDOR",
            unidade: itemFornecedorSelecionado.unidadeComercial
        });
    }

    // const onFilter = force => (value) => {
    //     setAutoCompleteValue(value);
    //     lerProdutos(force, value, (produtos)=>{
    //         const newOpts = produtos.map((p) => {
    //             return { 
    //                 key: p.id,
    //                 produto: p,
    //                 value: p.id,
    //                 label: (<div><input type="hidden" value={p.id}></input><span style={{fontWeight: "bold"}}>#{p.id} ##{p.codigo}</span> {p.descricao}</div>)
    //              }
    //         });

    //         setOptions(newOpts);
    //     });
    // };

    // const onSelect = (value, instancia) => {
    //     setMeuProdutoSelecionado(instancia.produto);
    //     setAutoCompleteValue(instancia.produto.descricao);
    // }
    
    // const removerProdutoSelecionado = () => {
    //     setMeuProdutoSelecionado(false);
    // }

    const deveInformarQuantidadeDebitar = () => {
        return meuProdutoSelecionado.uCom !== itemFornecedorSelecionado.unidadeComercial;
    }

    
    const qtdConferidaChangeHandler = (evt) => {
        const qtd = document.getElementById(evt.target.id).value;
        setQuantidadeEntradaExibicao({value:qtd});
        setQuantidadeDebitada(qtd);
    }
    
    const qtdDebitadaChangeHandler = (evt) => {
        const qtd = document.getElementById(evt.target.id).value;
        setQuantidadeDebitada(qtd);
    }

    const confirmaContagemEstoque = async () => {
        if(!meuProdutoSelecionado){
            alert("Nenhum produto selecionado");
        } else if(!quantidadeEntradaExibicao.value){
            alert("nenhuma quantidade de entrada foi informada");
        } else {
            setSalvandoMovimentacao(true);
            const fatorTransformacaoUnMedida = fatorTransformacao ;

            const valorUnRefAEntrada = itemFornecedorSelecionado.valorUn / fatorTransformacaoUnMedida;
            const subTotalRefAEntrada = valorUnRefAEntrada * quantidadeEntrada;
            const acrescimosRefAEntrada = ((itemFornecedorSelecionado.valoresAdicionais / itemFornecedorSelecionado.quantidade) / fatorTransformacaoUnMedida) * quantidadeEntrada;
            const descontosRefAEntrada =  ((itemFornecedorSelecionado.descontos / itemFornecedorSelecionado.quantidade) / fatorTransformacaoUnMedida) * quantidadeEntrada;
            const totalRefEntrada = ((itemFornecedorSelecionado.totalItem / itemFornecedorSelecionado.quantidade) / fatorTransformacaoUnMedida) * quantidadeEntrada;
            const validadeEnviar = (validade) ? moment(validade, 'DD/MM/YYYY').format("YYYY-MM-DD") : null;

            let qtdADebitar = quantidadeEntrada / fatorTransformacao;
            

            const movimentacaoDb = {                
                fluxo: "ENTRADA",
                quantidade: quantidadeEntrada,
                uuidProduto: meuProdutoSelecionado.uuid,
                origem: "NFe",
                uuidOrigem: itemFornecedorSelecionado.uuidNFe,
                uuidItemOrigem: itemFornecedorSelecionado.uuid,
                valorUn: valorUnRefAEntrada,
                subTotal : subTotalRefAEntrada,
                acrescimos: acrescimosRefAEntrada,
                descontos: descontosRefAEntrada,
                total: totalRefEntrada,
                quantidadeOrigem: qtdADebitar,
                observacao: "",
                lote: lote,
                validade: validadeEnviar
               
            }
            try{
                await salvarSaldoEstoque(movimentacaoDb);
                onSuccess(movimentacaoDb);
                setSalvandoMovimentacao(false);
            } catch(err){
                console.log(err);
                onClose();
            }

        }


    }

    const changeInputHandler = (setValue) => {
        return function(evt){
            const valor = evt.target.value;
            setValue(valor);
        }
    } 

    const changeDatePickerHendler = (setValue) => (momentDate, stringDate) => {
        setValue(momentDate);
    }
    
    const renderizaQuantidadeDebitar = () => {
       return (<>
       <Row>
            <Col>
                {quantidadeEntradaExibicao.value} {meuProdutoSelecionado.uCom} de seu produto {meuProdutoSelecionado.descricao} correspondem a quantos {itemFornecedorSelecionado.unidadeComercial} de seu fornecedor?
            </Col>
       </Row>
       <Row>
            <Col>
                <Input id='qtdDebitada' onChange={qtdDebitadaChangeHandler} type="text" placeholder="" value={quantidadeDebitada} prefix="" suffix={itemFornecedorSelecionado.unidadeComercial}></Input>
            </Col>
       </Row>
       </>);
    }

    

    const renderizaFormularioEntrada = () => {
        
        if(meuProdutoSelecionado){

            
            
           // const quantidadeDebitarRenderizado = deveInformarQuantidadeDebitar() ? renderizaQuantidadeDebitar() :(<></>);
        //    let padraoTransformacao = 1;
           
        //    if(itemSelecionado.unidadeTributario == meuProdutoSelecionado.uCom){
        //        padraoTransformacao = itemSelecionado.quantidadeTributaria / itemSelecionado.quantidade;
        //    }

           // setUnidadeMedidaDeConferencia(itemSelecionado.unidadeComercial);

           

           const alterarUnMedidaConferenciaHandler = (valor) => {
               setUnidadeMedidaDeConferencia(valor);
               console.log("antes", valor)
              // atualizaValorEntrada(valor);
              
           }

           
           const onChangeTransformacaoHandler = (evt) => {
               
                const valor = evt.target.value;
                let transformacao;
                if(valor == ""){
                    transformacao = 0;
                } else if(!isNaN(parseFloat(valor))){
                    transformacao = parseFloat(valor);
                    //padraoTransformacao = transformacao;
                
                } else {
                    transformacao=1;
                }
                setFatorTransformacao(transformacao);
                //atualizaValorEntrada();
               
               
           }

           
           
        
            return (<>
            
            <h3>Transformação</h3>
          
            <Row>
                <label for="bla">1 {itemFornecedorSelecionado.unidadeComercial} do meu fornecedor contem</label>
            </Row>
            <Row>
                <Input id="bla" value={fatorTransformacao} type="text" onChange={onChangeTransformacaoHandler} suffix={meuProdutoSelecionado.uCom + " do meu produto"} ></Input>
                
            </Row>
            <Divider></Divider>
            
            <h3>Conferência</h3>

            <SelecaoDeConferencia onChange={alterarUnMedidaConferenciaHandler} itemFornecedor={itemFornecedorSelecionado} produtoSelecionado={meuProdutoSelecionado}></SelecaoDeConferencia>
            
            <Row>
                <label for="qtdConferida">Informe a quantidade de Entrada</label>
            </Row>
            <Row>
                <Col><Input id='qtdConferida' value={quantidadeEntradaExibicao.value} type="text" onChange={qtdConferidaChangeHandler} placeholder="Quantidade Conferida" suffix={unidadeMedidaDeConferencia.unidade || itemFornecedorSelecionado.unidadeComercial}></Input></Col>
            </Row>
            
            <Row>
                <label for="validade">Validade</label>
            </Row>
            <Row>
                <Col>
                    <DatePicker id="validade" placeholder="Data de Validade" value={validade} onChange={changeDatePickerHendler(setValidade)} suffix="Valido Até" format="DD/MM/YYYY"  />
                </Col>
            </Row>
            <Row>
                <label for="lote" >Lote</label>
            </Row>
            <Row>
                <Col><Input id='lote' onChange={changeInputHandler(setLote)} value={lote} type="text" placeholder="Lote do produto, se houver"></Input></Col>
            </Row>

            
            </>);

        }
    }

    // const renderizaMeuProduto = () => {
    //     if(!meuProdutoSelecionado){

    //         return (<>  
    //             <Row gutter={[16,16]}>
    //                 <Col span={24}>
                    
    //                     <AutoComplete
    //                         style={{
    //                             width: "100%",
    //                         }}
    //                         value={autoCompleteValue}
    //                         dropdownMatchSelectWidth={500}
    //                         id="searchProduto"
    //                         placeholder="Informe o produto"
    //                         onSearch={onFilter(false)}
    //                         options={options}
    //                         onSelect={onSelect}
                            
    //                     >
    //                         <Input.Search  placeholder="Informe seu produto" enterButton={
    //                             <FontAwesomeIcon icon={faRedo}></FontAwesomeIcon>
    //                         }  onSearch={onFilter(true)} />



                            
    //                     </AutoComplete>
    //                 </Col>
    //                 <Divider></Divider>
    //                 <Col span={3}>
    //                     <FontAwesomeIcon size="4x" icon={faBoxCheck}></FontAwesomeIcon>
    //                 </Col>
    //                 <Col span={20}>
    //                     <h3>Cadastro do Produto</h3>
    //                     <p>Ainda não possui o produto cadastrado? Clique no botão abaixo para cadastrar com base nas informações do seu fornecedor</p>
    //                     <Button type={"primary"}>Importar Cadastro do Produto</Button>
    //                     <FormularioCadastroProduto onCancel={(evt)=>{}} getApi={async ()=>{}} visible={false} type="modal"></FormularioCadastroProduto>

    //                 </Col>
    //             </Row>
                
    //         </>)
    //     } else {
    //         return(
    //             <div>
    //                 <span style={{fontSize: "18px"}}>
    //                     <FontAwesomeIcon icon={faBoxOpen}></FontAwesomeIcon>
    //                     {meuProdutoSelecionado.descricao}</span> 
    //                     <Button onClick={removerProdutoSelecionado} danger={true} size="small" icon={(<FontAwesomeIcon icon={faExchange}></FontAwesomeIcon>)}>
    //                         Trocar
    //                     </Button>
    //             </div>
    //         )
    //         // return (<Tag closable={true}  onClose={removerProdutoSelecionado}>{meuProdutoSelecionado.descricao}</Tag>)
    //     }
    // }
 

    return(<>
        <Drawer
             title="Adicionar saldo do item da NFe"
             width={720}
             visible={visible}
             onClose={ () => {onClose()}}
             footer={(
                 <div style={{
                     textAlign: "right"
                    }}>
                        <Space>
                            <Button type="primary" onClick={confirmaContagemEstoque} loading={salvandoMovimentacao}>Confirmar</Button>
                        </Space>
                    </div>

             )}
        >
            <Row>
                <Col span={24}>
                    <h3 className="titulo">Item do Fornecedor</h3>
                </Col>
                
            </Row>
            <Row >
                <Col>
                   {itemFornecedorSelecionado.codigo} {itemFornecedorSelecionado.descricao}
                </Col>
                
                
            </Row>
           
            <Divider></Divider>
            <Space direction="vertical">
                <Row>
                    <Col>
                        <h3 className="titulo">Meu Produto</h3>
                    </Col>
                </Row>
                <Row >
                    <Col>
                        <ProdutoRenderizado produtoFornecedor={itemFornecedorSelecionado} meuProdutoSelecionado={meuProdutoSelecionado} setMeuProdutoSelecionado={setMeuProdutoSelecionado} ></ProdutoRenderizado>
                    </Col>                
                </Row>
                {renderizaFormularioEntrada()}
            </Space>
        </Drawer>
    </>);
}

export {AdicionaSaldoItemNFe};